import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button, FormGroup, Label, FormText,
} from 'reactstrap';
import {
  Field, reduxForm, formValueSelector, startSubmit,
} from 'redux-form';
import windowSize from 'react-window-size';
import {
  renderInput, required, Required, Optional,
} from '../../helpers/formHelper';
import * as Actions from '../../actions/schoolEntryActions';
import * as StudentActions from '../../actions/studentActions';
import SchoolApplicationForm from './SchoolApplicationForm';
import ParentFields from '../parent/ParentFields';
import PricePane from './PricePane';
import StudentFields from '../student/StudentFields';
import { Student } from '../../helpers/propTypes';

class View extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
  }

  componentDidMount() {
    const { students } = this.props.displays;
    if (students.length > 0) {
      this.props.setStudents(students);
      const { formValues } = this.props;
      if (formValues.student_id !== 'new') {
        this.props.setCurrentStudent();
      }
    }
    this.props.setIsFreeTrial(this.props.initialIsFreeTrial);
  }

  render() {
    const {
      invalid, submitting, hiddenFields, setSubmittingState,
      displays, loggedIn, formValues, prices, initialPcTypes,
      isFreeTrial, paymentStartDate, linkSvgPath, linkPngPcPath, linkPngSpPath, windowWidth,
    } = this.props;
    const SCREEN_SM = 576;

    return (
      <form action="/school_entry/confirm" method="post" ref={this.form} onSubmit={() => setSubmittingState('schoolEntryIndex')}>
        <div dangerouslySetInnerHTML={{ __html: hiddenFields }} />
        <Field name="authenticity_token" type="hidden" component="input" />
        {(!isFreeTrial && displays.stripeEnabled) && (
          // 一時的なキャンペーンバナー
          <a className="d-block mb-4" href="https://go.life-is-tech.com/l/946333/2023-02-03/bbrcy" target="_blank" rel="noopener noreferrer">
            <img src={`${windowWidth > SCREEN_SM ? linkPngPcPath : linkPngSpPath}`} alt="新中学一年生キャンペーンはこちら!!" />
          </a>
        )}
        {isFreeTrial && (
          <p className="mb-4" style={{ fontSize: '14px', padding: '0 14px' }}>
            ライフイズテックスクールに一ヶ月間無料でご参加いただける、無料体験お申込みフォームです。
            <br />
            無料体験後にスクールに本参加いただく場合、入塾金も無料となります！
            <br />
            下記に必要事項をご入力の上、お申込みください。
            <br />
            お申込み完了後、ご登録のメールアドレスに確認のメールをお送りいたします。
          </p>
        )}
        <SchoolApplicationForm
          displays={displays}
          linkSvgPath={linkSvgPath}
          initialPcTypes={initialPcTypes}
        />
        {!loggedIn && (
          <>
            <h2>保護者情報</h2>
            <ParentFields formName="schoolEntryIndex" />
          </>
        )}
        <h2>参加者情報</h2>
        {displays.students.length > 0 ? (
          <FormGroup className="students">
            <legend className="primary">参加者情報</legend>
            {displays.students.map((x) => (
              <FormGroup check inline key={x.id}>
                <Field
                  type="radio"
                  value={`${x.id}`}
                  component={renderInput}
                  name="student_id"
                  label={`${x.last_name} ${x.first_name}`}
                  id={`selected_student_id_${x.id}`}
                  validate={[required]}
                />
                {' '}
              </FormGroup>
            ))}
            <FormGroup check inline>
              <Field
                type="radio"
                value="new"
                component={renderInput}
                name="student_id"
                label="新しい参加者を入力する"
                id="selected_student_id_0"
                validate={[required]}
              />
              {' '}
            </FormGroup>
            {formValues.student_id !== 'new' && (
              <FormText>
                既にご登録済みの参加者情報を選択しています。
                <br />
                新しくご兄弟などを追加される場合は「新しい参加者を入力する」を選択してご入力ください。
              </FormText>
            )}
            <hr />
          </FormGroup>
        ) : (
          <Field name="student_id" type="hidden" component="input" />
        )}
        {formValues.student_id !== 'new' && (
          <>
            <Field name="student[first_name]" type="hidden" component="input" />
            <Field name="student[last_name]" type="hidden" component="input" />
            <Field name="student[first_name_kana]" type="hidden" component="input" />
            <Field name="student[last_name_kana]" type="hidden" component="input" />
            <Field name="student[gender]" type="hidden" component="input" />
            <Field name="student[birthday]" type="hidden" component="input" />
          </>
        )}
        <StudentFields
          formName="schoolEntryIndex"
          name="student"
          formValues={formValues}
          displays={displays}
          emailRequired
        />
        <FormGroup>
          <Label>ライフイズテックスクールをどうやって知りましたか</Label>
          <Required />
          <Field
            name="school_application[learned_reason_id]"
            type="select"
            component={renderInput}
            validate={[required]}
            id="school_application_learned_reason_id"
          >
            <option value="">お選びください</option>
            {displays.learned_reasons.map((x) => <option key={x.id} value={x.id}>{x.option_name}</option>)}
          </Field>
        </FormGroup>
        <FormGroup>
          <Label>質問・要望</Label>
          <Optional />
          <Field
            placeholder="質問・要望があればご記入ください"
            name="school_application[comment]"
            type="textarea"
            component={renderInput}
            validate={[]}
          />
        </FormGroup>
        <FormGroup>
          <Label>パソコン経験</Label>
          <Optional />
          <Field
            name="school_application[experience_id]"
            type="select"
            component={renderInput}
            validate={[]}
            id="school_application_experience_id"
          >
            <option value="">お選びください</option>
            {displays.experiences.map((x) => <option key={x.id} value={x.id}>{x.option_name}</option>)}
          </Field>
        </FormGroup>

        {!this.props.initialIsFreeTrial && displays.stripeEnabled && (
          <FormGroup tag="fieldset">
            <Label>クーポンをお持ちの方</Label>
            <Optional />
            <Field
              name="coupon_code"
              type="input"
              component={renderInput}
              disabled={$.isEmptyObject(prices)}
            />
            <FormText color="muted" className="mb-3">
              使用できるクーポンコードは一つのみになります。
              <br />
              お申込み後にクーポンを使用することはできません。
            </FormText>
          </FormGroup>
        )}
        {displays.stripeEnabled ? <PricePane paymentStartDate={paymentStartDate} /> : (
          <>
            <h2>お支払い情報</h2>
            <div dangerouslySetInnerHTML={{ __html: displays.tagNote }} />
          </>
        )}
        <Button
          className="submit"
          type="submit"
          disabled={invalid || submitting}
          color="danger"
          size="lg"
        >
          確認画面へ
        </Button>
      </form>
    );
  }
}

View.propTypes = {
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  hiddenFields: PropTypes.string.isRequired,
  displays: PropTypes.shape({
    learned_reasons: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      option_name: PropTypes.string,
    })).isRequired,
    experiences: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      option_name: PropTypes.string,
    })).isRequired,
    birthday: PropTypes.arrayOf(PropTypes.number).isRequired,
    gradeList: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]))).isRequired,
    students: PropTypes.arrayOf(Student).isRequired,
  }).isRequired,
  loggedIn: PropTypes.bool.isRequired,
  formValues: PropTypes.shape({
    authenticity_token: PropTypes.string,
  }).isRequired,
  setStudents: PropTypes.func.isRequired,
  setCurrentStudent: PropTypes.func.isRequired,
  setIsFreeTrial: PropTypes.func.isRequired,
  prices: PropTypes.shape({
  }).isRequired,
  setSubmittingState: PropTypes.func.isRequired,
  isFreeTrial: PropTypes.bool.isRequired,
  initialIsFreeTrial: PropTypes.bool.isRequired,
  paymentStartDate: PropTypes.instanceOf(Date).isRequired,
  linkSvgPath: PropTypes.string.isRequired,
  linkPngPcPath: PropTypes.string.isRequired,
  linkPngSpPath: PropTypes.string.isRequired,
  windowWidth: PropTypes.number.isRequired,
  initialPcTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })).isRequired,
};

const selector = formValueSelector('schoolEntryIndex');
export default reduxForm({
  form: 'schoolEntryIndex',
  validate: (values, props) => {
    const errors = {};
    if (props.displays.students.length > 0
       && values.student_id === 'new'
       && props.displays.students.some((x) => x.last_name + x.first_name === values.student.last_name + values.student.first_name)) {
      return {
        ...errors,
        student: {
          first_name: 'ご入力の参加者情報はすでに登録済みです。上記よりご選択ください。',
        },
      };
    }
    return errors;
  },
})(connect((state) => ({
  formValues: selector(
    state,
    'authenticity_token',
    'school_application[course_id]',
    'school_application[school_location_id]',
    'school_application[day_location_id]',
    'parent[last_name]',
    'parent[send_mail_magazine]',
    'student[school_name]',
    'student[allergy_flag]',
    'student_id',
  ),
  schoolNames: state.schoolEntry.schoolNames,
  loadingSchoolNames: state.schoolEntry.loadingSchoolNames,
  prices: state.schoolEntry.prices,
  setStudents: state.schoolEntry.students,
  courses: state.schoolEntry.courses,
  dayLocations: state.schoolEntry.dayLocations,
  isFreeTrial: state.schoolEntry.isFreeTrial,
}), (dispatch) => ({
  setSubmittingState: (formId) => {
    dispatch(startSubmit(formId));
  },
  setStudents: (value) => dispatch(StudentActions.setStudents(value)),
  setCurrentStudent: (payload) => dispatch({
    type: StudentActions.SAGA_SET_CURRENT_STUDENT,
    payload,
  }),
  setIsFreeTrial: (payload) => dispatch(Actions.setIsFreeTrial(payload)),
}))(windowSize(View)));
